var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    viewBox: "0 0 1500 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 286.13 100.05)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-504.13, -1000.05)",
    d: "M 482.5 1035.3 c -3.72 0 -6.92 -1.34 -9.6 -4.01 c -2.68 -2.68 -4.01 -5.87 -4.01 -9.6 v -43.28 c 0 -3.72 1.34 -6.92 4.01 -9.6 c 2.68 -2.68 5.87 -4.01 9.6 -4.01 h 43.18 c 3.79 0 7.02 1.34 9.69 4.01 c 2.68 2.68 4.01 5.87 4.01 9.6 v 5.48 h -13.02 v -2.64 c 0 -1.83 -0.13 -2.86 -0.39 -3.08 c -0.26 -0.23 -1.27 -0.34 -3.04 -0.34 h -37.7 c -1.83 0 -2.86 0.11 -3.08 0.34 c -0.23 0.23 -0.34 1.26 -0.34 3.08 v 37.6 c 0 1.83 0.11 2.86 0.34 3.08 c 0.23 0.23 1.26 0.34 3.08 0.34 h 37.7 c 1.76 0 2.77 -0.11 3.04 -0.34 c 0.26 -0.23 0.39 -1.26 0.39 -3.08 v -10.48 h -15.96 v -13.02 h 28.98 v 26.34 c 0 3.72 -1.34 6.92 -4.01 9.6 c -2.68 2.68 -5.91 4.01 -9.69 4.01 H 482.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 385.23 100.05)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-603.23, -1000.05)",
    d: "M 567.98 1035.3 v -56.89 c 0 -3.72 1.34 -6.92 4.01 -9.6 c 2.68 -2.68 5.87 -4.01 9.6 -4.01 h 43.18 c 3.78 0 7.02 1.34 9.69 4.01 c 2.68 2.68 4.01 5.87 4.01 9.6 v 56.89 h -13.02 v -23.7 H 580.9 v 23.7 H 567.98 z M 580.9 998.68 h 44.55 v -17.43 c 0 -1.83 -0.13 -2.86 -0.39 -3.08 c -0.26 -0.23 -1.27 -0.34 -3.04 -0.34 h -37.7 c -1.83 0 -2.86 0.11 -3.08 0.34 c -0.23 0.23 -0.34 1.26 -0.34 3.08 V 998.68 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 484.62 100)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-702.62, -1000)",
    d: "M 667.37 1035.3 v -70.6 h 12.92 v 57.58 h 57.57 v 13.02 H 667.37 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 578.61 100.05)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-796.61, -1000.05)",
    d: "M 761.36 1035.3 v -56.89 c 0 -3.72 1.34 -6.92 4.01 -9.6 c 2.68 -2.68 5.87 -4.01 9.6 -4.01 h 43.18 c 3.78 0 7.02 1.34 9.69 4.01 c 2.68 2.68 4.01 5.87 4.01 9.6 v 56.89 h -13.02 v -23.7 h -44.55 v 23.7 H 761.36 z M 774.29 998.68 h 44.55 v -17.43 c 0 -1.83 -0.13 -2.86 -0.39 -3.08 c -0.26 -0.23 -1.27 -0.34 -3.04 -0.34 h -37.7 c -1.83 0 -2.86 0.11 -3.09 0.34 c -0.23 0.23 -0.34 1.26 -0.34 3.08 V 998.68 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 677.8 100.05)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-895.8, -1000.05)",
    d: "M 874.26 1035.3 c -3.72 0 -6.92 -1.34 -9.6 -4.01 c -2.68 -2.68 -4.01 -5.87 -4.01 -9.6 v -43.28 c 0 -3.72 1.34 -6.92 4.01 -9.6 c 2.68 -2.68 5.87 -4.01 9.6 -4.01 h 56.69 v 13.02 H 877 c -1.83 0 -2.86 0.11 -3.09 0.34 c -0.23 0.23 -0.34 1.26 -0.34 3.08 v 37.6 c 0 1.83 0.11 2.86 0.34 3.08 c 0.23 0.23 1.26 0.34 3.09 0.34 h 53.95 v 13.02 H 874.26 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 772.48 100.05)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-990.48, -1000.05)",
    d: "M 984.02 1035.3 v -57.48 h -28.79 V 964.8 h 70.5 v 13.02 h -28.69 v 57.48 H 984.02 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 838.72 100.05)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1056.72, -1000.05)",
    d: "M 1050.31 1035.3 v -70.5 h 12.83 v 70.5 H 1050.31 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 906.43 100.05)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1124.43, -1000.05)",
    d: "M 1102.89 1035.3 c -3.72 0 -6.92 -1.34 -9.6 -4.01 c -2.68 -2.68 -4.01 -5.87 -4.01 -9.6 v -43.28 c 0 -3.72 1.34 -6.92 4.01 -9.6 c 2.68 -2.68 5.87 -4.01 9.6 -4.01 h 56.69 v 13.02 h -53.95 c -1.83 0 -2.86 0.11 -3.09 0.34 c -0.23 0.23 -0.34 1.26 -0.34 3.08 v 37.6 c 0 1.83 0.11 2.86 0.34 3.08 c 0.23 0.23 1.26 0.34 3.09 0.34 h 53.95 v 13.02 H 1102.89 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 1052.22 100.05)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1270.22, -1000.05)",
    d: "M 1248.59 1035.3 c -3.72 0 -6.92 -1.34 -9.6 -4.01 c -2.68 -2.68 -4.01 -5.87 -4.01 -9.6 v -43.28 c 0 -3.72 1.34 -6.92 4.01 -9.6 c 2.68 -2.68 5.87 -4.01 9.6 -4.01 h 43.18 c 3.78 0 7.02 1.34 9.69 4.01 c 2.68 2.68 4.01 5.87 4.01 9.6 v 5.48 h -13.02 v -2.64 c 0 -1.83 -0.13 -2.86 -0.39 -3.08 c -0.26 -0.23 -1.27 -0.34 -3.04 -0.34 h -37.7 c -1.83 0 -2.86 0.11 -3.09 0.34 c -0.23 0.23 -0.34 1.26 -0.34 3.08 v 37.6 c 0 1.83 0.11 2.86 0.34 3.08 c 0.23 0.23 1.26 0.34 3.09 0.34 h 37.7 c 1.76 0 2.77 -0.11 3.04 -0.34 c 0.26 -0.23 0.39 -1.26 0.39 -3.08 v -10.48 h -15.96 v -13.02 h 28.98 v 26.34 c 0 3.72 -1.34 6.92 -4.01 9.6 c -2.68 2.68 -5.91 4.01 -9.69 4.01 H 1248.59 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 1151.03 100.1)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1369.03, -1000.1)",
    d: "M 1333.78 1035.3 v -70.4 h 56.79 c 3.78 0 7.02 1.36 9.69 4.06 c 2.68 2.71 4.01 5.89 4.01 9.55 v 19 c 0 3.72 -1.34 6.92 -4.01 9.6 c -2.68 2.68 -5.91 4.01 -9.69 4.01 h -3.82 l 17.43 20.56 v 3.62 h -14.1 l -20.27 -24.18 l -23.11 0.1 v 24.09 H 1333.78 z M 1350.13 998.09 h 37.7 c 1.76 0 2.76 -0.1 2.99 -0.29 c 0.23 -0.2 0.34 -1.21 0.34 -3.04 v -13.51 c 0 -1.83 -0.11 -2.86 -0.34 -3.08 c -0.23 -0.23 -1.22 -0.34 -2.99 -0.34 h -37.7 c -1.83 0 -2.86 0.11 -3.08 0.34 c -0.23 0.23 -0.34 1.26 -0.34 3.08 v 13.51 c 0 1.83 0.11 2.84 0.34 3.04 C 1347.27 997.99 1348.3 998.09 1350.13 998.09 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 1249.33 100.05)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1467.33, -1000.05)",
    d: "M 1445.69 1035.3 c -3.72 0 -6.92 -1.34 -9.6 -4.01 c -2.68 -2.68 -4.01 -5.87 -4.01 -9.6 v -43.28 c 0 -3.72 1.34 -6.92 4.01 -9.6 c 2.68 -2.68 5.87 -4.01 9.6 -4.01 h 43.28 c 3.72 0 6.92 1.34 9.6 4.01 c 2.68 2.68 4.01 5.87 4.01 9.6 v 43.28 c 0 3.72 -1.34 6.92 -4.01 9.6 c -2.68 2.68 -5.87 4.01 -9.6 4.01 H 1445.69 z M 1448.44 1022.28 h 37.7 c 1.76 0 2.77 -0.11 3.04 -0.34 c 0.26 -0.23 0.39 -1.26 0.39 -3.08 v -37.6 c 0 -1.83 -0.13 -2.86 -0.39 -3.08 c -0.26 -0.23 -1.27 -0.34 -3.04 -0.34 h -37.7 c -1.83 0 -2.86 0.11 -3.09 0.34 c -0.23 0.23 -0.34 1.26 -0.34 3.08 v 37.6 c 0 1.83 0.11 2.86 0.34 3.08 C 1445.58 1022.16 1446.61 1022.28 1448.44 1022.28 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 1348.04 100.05)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1566.04, -1000.05)",
    d: "M 1544.39 1035.3 c -3.72 0 -6.92 -1.34 -9.6 -4.01 c -2.68 -2.68 -4.01 -5.87 -4.01 -9.6 V 964.8 h 12.93 v 54.05 c 0 1.83 0.11 2.86 0.34 3.08 c 0.23 0.23 1.26 0.34 3.09 0.34 h 37.7 c 1.76 0 2.77 -0.11 3.04 -0.34 c 0.26 -0.23 0.39 -1.26 0.39 -3.08 V 964.8 h 13.02 v 56.89 c 0 3.72 -1.34 6.92 -4.01 9.6 c -2.68 2.68 -5.87 4.01 -9.6 4.01 H 1544.39 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 1446.93 100.11)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1664.93, -1000.11)",
    d: "M 1629.68 1035.3 v -70.4 h 56.79 c 3.78 0 7.02 1.36 9.69 4.06 c 2.68 2.71 4.01 5.89 4.01 9.55 v 19 c 0 3.72 -1.34 6.92 -4.01 9.6 c -2.68 2.68 -5.91 4.01 -9.69 4.01 l -43.87 0.1 v 24.09 H 1629.68 z M 1646.03 998.09 h 37.7 c 1.76 0 2.77 -0.1 3.04 -0.29 c 0.26 -0.2 0.39 -1.21 0.39 -3.04 v -13.51 c 0 -1.83 -0.13 -2.86 -0.39 -3.08 c -0.26 -0.23 -1.27 -0.34 -3.04 -0.34 h -37.7 c -1.83 0 -2.86 0.11 -3.09 0.34 c -0.23 0.23 -0.34 1.26 -0.34 3.08 v 13.51 c 0 1.83 0.11 2.84 0.34 3.04 C 1643.17 997.99 1644.2 998.09 1646.03 998.09 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 124.74 122.73)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_SVGID_1__5",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 370.1422,
    y1: 927.4412,
    x2: 424.7031,
    y2: 1073.4966
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(26,229,218)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(98,120,238)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_SVGID_1__5)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-405.74, -1022.73)",
    d: "M 442.42 1022.73 h -36.68 v 36.67 c -20.25 0 -36.68 -16.41 -36.68 -36.67 s 16.42 -36.68 36.68 -36.68 S 442.42 1002.48 442.42 1022.73 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 71.78 69.78)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_SVGID_2__6",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 341.03,
    y1: 938.3163,
    x2: 395.591,
    y2: 1084.3718
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(26,229,218)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(98,120,238)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_SVGID_2__6)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-352.78, -969.78)",
    d: "M 309.57 1022.73 h -9.74 c 0 -58.4 47.51 -105.91 105.91 -105.91 v 9.74 C 352.71 926.56 309.57 969.7 309.57 1022.73 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 83.15 81.14)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_SVGID_3__7",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 347.2777,
    y1: 935.9825,
    x2: 401.8386,
    y2: 1082.038
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(26,229,218)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(98,120,238)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_SVGID_3__7)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-364.15, -981.14)",
    d: "M 332.3 1022.73 h -9.74 c 0 -45.87 37.32 -83.18 83.18 -83.18 v 9.74 C 365.24 949.29 332.3 982.23 332.3 1022.73 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 94.51 122.73)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_SVGID_4__8",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 351.7335,
    y1: 934.318,
    x2: 406.2944,
    y2: 1080.3734
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(26,229,218)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(98,120,238)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_SVGID_4__8)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-375.51, -1022.73)",
    d: "M 405.74 1083.18 c -33.33 0 -60.45 -27.12 -60.45 -60.45 c 0 -33.33 27.12 -60.45 60.45 -60.45 v 9.74 c -27.96 0 -50.71 22.75 -50.71 50.71 s 22.75 50.71 50.71 50.71 V 1083.18 z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.0b6028bf3c72886384355d1064c7add9.svg";
export { ForwardRef as ReactComponent };